import { DeleteOutlined } from "@ant-design/icons";
import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  notification,
  Result,
  Row,
  Space,
} from "antd";
import { FetchWithAuth } from "digimaker-ui/util";
import React, { useEffect } from "react";
import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import * as XLSX from "xlsx";

export const AddTourist = () => {
  const [success, setSuccess] = useState(false);

  const [group, setGroup] = useState({} as any);
  const [form] = Form.useForm();

  const [values, setValues] = useState([]);

  const params = useParams();

  const keys = ["fullname", "passport"];

  useEffect(() => {
    FetchWithAuth("/api/ns/tourist_group/get?id=" + params.group).then(
      (data) => {
        if (data.error) { notification.error({ message: data.data.message }); return; }
        setGroup(data.data);
      }
    );
    addRow();
  }, []);

  const addRow = () => {
    let obj = {};
    keys.map((k) => (obj[k] = ""));
    console.log(obj);
    setValues([...values, obj]);
  };

  const deleteRow = (i) => {
    let v = [...values];
    console.log(i);
    v.splice(i, 1);
    setValues(v);
  };

  const inputFileRef = React.useRef(null);

  const uploadFile = (e) => {
    let file = e.target.files[0];

    const reader = new FileReader();
    reader.onloadend = () => {
      const workbook = XLSX.read(reader.result, { type: "array" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const list = (XLSX.utils.sheet_to_json(sheet, { defval: "" }) as any[]).map(
        ({ name, ...rest }) => ({ fullname: name, ...rest })
      );
      setValues(list);
      form.setFieldsValue(list);
    };
    reader.readAsArrayBuffer(file);
  };

  const submit = (data) => {
    let arr = [];
    Object.keys(data).map((k) => {
      const row = data[k];
      arr.push(row);
    });
    FetchWithAuth("/api/ns/tourist/add?group=" + params["group"], {
      method: "POST",
      body: JSON.stringify(arr),
    }).then((resp) => {
      if (resp.error) { notification.error({ message: resp.data.message }); return; }
      if (resp.data === 1) {
        setSuccess(true);
      }
    });
  };

  const colProps = { style: { padding: "2px 5px" } };

  return (
    <div>
      <h2>{group.name} - 添加成员</h2>
      <Space>
        <Button onClick={() => addRow()}>添加行</Button>
        <Button onClick={() => inputFileRef.current.click()}>导入Excel</Button>
        <input
          style={{ display: "none" }}
          type="file"
          name="myFile"
          ref={inputFileRef}
          accept=".xlsx,.xls"
          onChange={uploadFile}
        />
      </Space>
      <br /> <br />
      {success && (
        <Result
          status="success"
          title="添加成功"
          subTitle="成员已经添加"
          extra={[
            <Link to="/group/list">
              <Button type="primary" key="back">
                回到列表
              </Button>
            </Link>,
            <Button key="add" onClick={() => setSuccess(false)}>
              再次添加
            </Button>,
          ]}
        />
      )}
      {!success && (
        <Form form={form} onFinish={submit}>
          {values.map((row, i) => (
            <Row key={JSON.stringify(row) + i}>
              <Col span={6} {...colProps}>
                <Form.Item
                  label="姓名"
                  name={[i, "fullname"]}
                  rules={[{ required: true, message: "请输入姓名" }]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={4} {...colProps}>
                <Form.Item
                  label="护照号"
                  name={[i, "passport"]}
                  rules={[{ required: true, message: "请输入护照号" }]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={4} {...colProps}>
                <Form.Item label="电话" name={[i, "mobile"]}>
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6} {...colProps}>
                <Form.Item label="邮件" name={[i, "email"]}>
                  <Input type="email" />
                </Form.Item>
              </Col>
              <Col>
                <Button
                  type="text"
                  title="Delete row"
                  onClick={() => deleteRow(i)}
                >
                  <DeleteOutlined />
                </Button>
              </Col>
            </Row>
          ))}

          <div>
            <Space>
              <Button type="primary" htmlType="submit">
                确定
              </Button>
              <Button htmlType="reset">重设</Button>
              <Button type="link" onClick={() => window.history.back()}>
                返回
              </Button>
            </Space>
          </div>
        </Form>
      )}
    </div>
  );
};
